import React from "react";
import { NavLink } from "react-router-dom";
import {
  FolderOpen,
  FileText,
  ClipboardList,
  Home,
  LayoutDashboard,
  Users,
  Palette,
} from "lucide-react";

const navItems = [
  {
    label: "Home",
    to: "/admin",
    icon: Home,
  },
  {
    label: "Legacy Profiles",
    to: "/admin/legacy-profiles",
    icon: FolderOpen,
  },
  {
    label: "Templates",
    to: "/admin/questionnaire/templates",
    icon: FileText,
  },
  {
    label: "Brand Profiles",
    to: "/admin/questionnaire/responses",
    icon: ClipboardList,
  },
  {
    label: "Dashboard",
    to: "/admin/dashboard",
    icon: LayoutDashboard,
  },
  {
    label: "Onboarding",
    to: "/admin/onboarding",
    icon: Users,
  },
  {
    label: "Manual Brand Pages",
    to: "/admin/manual-brand-pages",
    icon: Palette,
  },
];

const AdminNav = () => {
  return (
    <nav className="hidden md:block w-64 flex-shrink-0 border-r border-white/10 bg-[#111111] min-h-screen p-4">
      <div className="flex flex-col gap-2">
        {navItems.map(({ label, to, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/admin"} // only exact for home
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                isActive
                  ? "bg-primary-green/20 text-primary-green"
                  : "text-white/70 hover:bg-white/10 hover:text-white"
              }`
            }
          >
            <Icon className="w-4 h-4" />
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default AdminNav;
